/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskZoomInfoOrgChart } from './ExecRiskZoomInfoOrgChart';
import {
    ExecRiskZoomInfoOrgChartFromJSON,
    ExecRiskZoomInfoOrgChartFromJSONTyped,
    ExecRiskZoomInfoOrgChartToJSON,
} from './ExecRiskZoomInfoOrgChart';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedZoomInfoOrgchartResponse
 */
export interface ExecRiskPaginatedZoomInfoOrgchartResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoOrgchartResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskZoomInfoOrgChart>}
     * @memberof ExecRiskPaginatedZoomInfoOrgchartResponse
     */
    results: Array<ExecRiskZoomInfoOrgChart>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedZoomInfoOrgchartResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoOrgchartResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoOrgchartResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedZoomInfoOrgchartResponse interface.
 */
export function instanceOfExecRiskPaginatedZoomInfoOrgchartResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedZoomInfoOrgchartResponseFromJSON(json: any): ExecRiskPaginatedZoomInfoOrgchartResponse {
    return ExecRiskPaginatedZoomInfoOrgchartResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedZoomInfoOrgchartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedZoomInfoOrgchartResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskZoomInfoOrgChartFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedZoomInfoOrgchartResponseToJSON(value?: ExecRiskPaginatedZoomInfoOrgchartResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskZoomInfoOrgChartToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

